export default "__VITE_ASSET__KI0qsz0p__"